import _cloneDeep from 'lodash/cloneDeep';

export default {
  serviceRequest: (state) => _cloneDeep(state.serviceRequest),
  serviceRequests: (state) => _cloneDeep(state.serviceRequests),
  serviceRequestTask: (state) => _cloneDeep(state.serviceRequestTask),
  serviceRequestTasks: (state) => _cloneDeep(state.serviceRequestTasks),
  showServiceRequestTasks: (state) => state.showServiceRequestTasks,
};
